import React from 'react'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

export default function EEGChildSummaryInformationProcessingSpeedAPI(props: {
  informationProcessingSpeedGraphImage: string | undefined
  // frontalLobeDevelopmentColorbarImage: string | undefined
  percentile: number
  // maxRange: number
  score: number
  isSummary?: boolean
}) {
  const {informationProcessingSpeedGraphImage, percentile, score, isSummary} =
    props

  const isDisable = (!percentile && percentile < 0) || (!score && score < 0)
  const {textEegAPI} = useLanguage('eeg')
  const classes = useStyles()

  return (
    <div className={classes.eeg} style={{marginTop: 45}}>
      {isSummary ? (
        <ReportSubtitleV1 number='2'>
          {textEegAPI?.infant_youth.section.information_processing_speed.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number='2'>
          {textEegAPI?.infant_youth.section.information_processing_speed.title}
        </ReportSubtitle>
      )}

      <div className={classes.childValueGraph}>
        <div className='Child-Graph'>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img
            src={informationProcessingSpeedGraphImage}
            alt='brain wave analysis 3d image'
          />
        </div>
        <div className='Child-info'>
          <div
            style={{
              backgroundColor: !isDisable ? '#00a29c' : '#e0e0e0',
              color: '#FFF',
              padding: '15px 24px',
              marginTop: 84,
              marginBottom: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <span className='Range'>
              <span
                style={{display: 'inline-block', maxWidth: '65%'}}
                // @ts-ignore
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: simpleSanitizeHTML(
                    textEegAPI?.infant_youth.section
                      .information_processing_speed.score_bar.percentile ?? '',
                  ),
                }}
              />

              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              {(percentile == null || percentile < 0) && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label
                  className='ScoreValue'
                  style={{color: '#f55856f !important'}}
                >
                  {`    - %ile`}
                </label>
              )}
              {percentile != null && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className='ScoreValue'>
                  {`    ${percentile === 0 ? '0.0' : percentile} %ile     `}
                </label>
              )}
            </span>
            <span
              className='Score scoreWrapText'
              style={{marginLeft: 0, display: 'flex', alignItems: 'center'}}
            >
              <span>
                {
                  textEegAPI?.infant_youth.section.information_processing_speed
                    .score_bar.value
                }
              </span>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              {score == null && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className='ScoreNullValue'>- Hz</label>
              )}
              {score != null && (
                <div>
                  <span
                    className='ScoreValue'
                    style={{color: !isDisable ? '#00a29c' : '#e0e0e0'}}
                  >
                    {`${score || '-'} Hz`}
                  </span>
                </div>
              )}
            </span>
          </div>
          <div className='Child-info-alert'>
            {
              textEegAPI?.infant_youth.section.information_processing_speed
                .score_bar.annotation
            }
          </div>
          <div
            className='Title'
            style={{color: '#000000', marginBottom: '20px'}}
          >
            {
              textEegAPI?.infant_youth.section.information_processing_speed
                .description.main
            }
          </div>
          <div className='Desc' style={{color: '#333333'}}>
            {
              textEegAPI?.infant_youth.section.information_processing_speed
                .description.sub[0]
            }
            <br />
            {
              textEegAPI?.infant_youth.section.information_processing_speed
                .description.sub[1]
            }
          </div>
        </div>
      </div>
    </div>
  )
}
